//  здесь мы синтезируем "латинское" KeyboardEvent при использовании иной раскладки — тогда Collabora отрабатывает свой
// родной обработчик без знания о раскладке.
// На cross-origin доступ к contentDocument бросит SecurityError — в этом
// случае мост просто не устанавливается, поведение остаётся прежним.

type KeyMapping = { key: string; keyCode: number };

const SHORTCUT_KEY_MAP: Record<string, KeyMapping> = {
  KeyA: { key: 'a', keyCode: 65 },
  KeyB: { key: 'b', keyCode: 66 },
  KeyC: { key: 'c', keyCode: 67 },
  KeyD: { key: 'd', keyCode: 68 },
  KeyE: { key: 'e', keyCode: 69 },
  KeyF: { key: 'f', keyCode: 70 },
  KeyG: { key: 'g', keyCode: 71 },
  KeyH: { key: 'h', keyCode: 72 },
  KeyI: { key: 'i', keyCode: 73 },
  KeyJ: { key: 'j', keyCode: 74 },
  KeyK: { key: 'k', keyCode: 75 },
  KeyL: { key: 'l', keyCode: 76 },
  KeyM: { key: 'm', keyCode: 77 },
  KeyN: { key: 'n', keyCode: 78 },
  KeyO: { key: 'o', keyCode: 79 },
  KeyP: { key: 'p', keyCode: 80 },
  KeyQ: { key: 'q', keyCode: 81 },
  KeyR: { key: 'r', keyCode: 82 },
  KeyS: { key: 's', keyCode: 83 },
  KeyT: { key: 't', keyCode: 84 },
  KeyU: { key: 'u', keyCode: 85 },
  KeyV: { key: 'v', keyCode: 86 },
  KeyW: { key: 'w', keyCode: 87 },
  KeyX: { key: 'x', keyCode: 88 },
  KeyY: { key: 'y', keyCode: 89 },
  KeyZ: { key: 'z', keyCode: 90 },
};

const isLatinLetter = (value: string | undefined): boolean => {
  return !!value && value.length === 1 && /^[a-zA-Z]$/.test(value);
};



const dispatchLatinKeydown = (
  originalEvent: KeyboardEvent,
  mapping: KeyMapping
): void => {
  const target = (originalEvent.target as HTMLElement) || null;

  if (!target) {
    return;
  }

  const shouldUpperCase = originalEvent.shiftKey;
  const latinKey = shouldUpperCase ? mapping.key.toUpperCase() : mapping.key;

  const fakeEvent = new KeyboardEvent('keydown', {
    key: latinKey,
    code: originalEvent.code,
    ctrlKey: originalEvent.ctrlKey,
    metaKey: originalEvent.metaKey,
    altKey: originalEvent.altKey,
    shiftKey: originalEvent.shiftKey,
    bubbles: true,
    cancelable: true,
    composed: true,
   
  });

  Object.defineProperty(fakeEvent, 'keyCode', { get: () => mapping.keyCode });
  Object.defineProperty(fakeEvent, 'which', { get: () => mapping.keyCode });
  Object.defineProperty(fakeEvent, 'charCode', { get: () => 0 });


  target.dispatchEvent(fakeEvent);
};

const handleKeydown = (event: KeyboardEvent, iframeWindow: Window): void => {
  if (!event.ctrlKey && !event.metaKey) {
    return;
  }

  const mapping = SHORTCUT_KEY_MAP[event.code];
  if (!mapping) {
    return;
  }

  if (isLatinLetter(event.key)) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (event.code === 'KeyS' && !event.altKey && !event.shiftKey) {
     iframeWindow.postMessage(
    JSON.stringify({
      MessageId: 'Action_Save',
      Values: { Notify: true },
    }),
    '*'
  );
  console.log('sendActionSave');
    return;
  }

  dispatchLatinKeydown(event, mapping);
};

export const installCollaboraShortcutBridge = (
  iframe: HTMLIFrameElement | null
): (() => void) => {
  if (!iframe) {
    return () => {};
  }

  let iframeDocument: Document | null = null;
  let iframeWindow: Window | null = null;

  try {
    iframeDocument = iframe.contentDocument;
    iframeWindow = iframe.contentWindow;
    // Чтение location триггерит SecurityError на cross-origin, если стучимся к коллаборе на тесте, таким образом локально работать не будет пока что
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    iframeWindow?.location.href;
  } catch (e) {
    console.log('error', e);
  }

  if (!iframeDocument || !iframeWindow) {
    return () => {};
  }
  const listener = (event: Event) => handleKeydown(event as KeyboardEvent, iframeWindow);

  iframeDocument.addEventListener('keydown', listener, { capture: true });

  return () => {
    try {
      iframeDocument?.removeEventListener('keydown', listener, { capture: true } as any);
    } catch (e) {
    }
  };
};
